import { render, staticRenderFns } from "./footerBox.vue?vue&type=template&id=724cf435&scoped=true"
import script from "./footerBox.vue?vue&type=script&lang=js"
export * from "./footerBox.vue?vue&type=script&lang=js"
import style0 from "./footerBox.vue?vue&type=style&index=0&id=724cf435&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724cf435",
  null
  
)

export default component.exports